export const OPEN_AI_DYNAMIC_TOKEN_MODAL_ACTION = 'hsaidynamictokens:openModal';